import { createStatusReducer } from '../../helpers/reducers';
import { types } from '../../actions/tara';
import * as routeTypes from '../../routes/types';

const initialState = '';

const apiActionTypes = [
  types.TARA_POST_SURVEY,
];

const routeActionTypes = [
];

const status = createStatusReducer(initialState, apiActionTypes, routeActionTypes);

export default status;

export const getStatus = state => state.tara.status;



// WEBPACK FOOTER //
// ./src/reducers/tara/status.js